<template>
  <button
    type="button"
    class="pp-back"
    :aria-label="t('common.actions.back')"
    @click="$emit('click')"
  >
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M15 6l-6 6 6 6" />
    </svg>
  </button>
</template>

<script setup lang="ts">
defineEmits<{
  (e: 'click'): void;
}>();

const { t } = useI18n();
</script>

<style scoped lang="scss">
.pp-back {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 1.5px solid rgba(13, 15, 21, 0.4);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0d0f15;
  flex-shrink: 0;
  background: white;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #f3f3f3;
    border-color: #0d0f15;
  }
}
</style>
